import { BehaviorSubject, Subject } from "rxjs";
import tippy from 'tippy.js';
import { JQElementHelper } from "../../lib/JQElementHelper";
import { AxDropdownInteraction } from './AxDropdownInteraction';
const keyAction = {
    close: 0,
    closeSelect: 1,
    first: 2,
    last: 3,
    next: 4,
    open: 5,
    pageDown: 6,
    pageUp: 7,
    previous: 8,
    select: 9,
    type: 10,
};
const getAction = (event, isOpen) => {
    const { key, altKey, ctrlKey, metaKey } = event;
    const openKeys = ['ArrowDown', 'ArrowUp', 'Enter', ' '];
    if (!isOpen && openKeys.includes(key)) {
        return keyAction.open;
    }
    if (key === 'Home') {
        return keyAction.first;
    }
    if (key === 'End') {
        return keyAction.last;
    }
    if (key === 'Backspace' ||
        key === 'Clear' ||
        (key.length === 1 && key !== ' ' && !altKey && !ctrlKey && !metaKey)) {
        return keyAction.type;
    }
    if (isOpen) {
        if (key === 'ArrowUp' && altKey) {
            return keyAction.closeSelect;
        }
        else if (key === 'ArrowDown' && !altKey) {
            return keyAction.next;
        }
        else if (key === 'ArrowUp') {
            return keyAction.previous;
        }
        else if (key === 'PageUp') {
            return keyAction.pageUp;
        }
        else if (key === 'PageDown') {
            return keyAction.pageDown;
        }
        else if (key === 'Escape') {
            return keyAction.close;
        }
        else if (key === 'Tab') {
            return keyAction.close;
        }
        else if (key === 'Enter' || key === ' ') {
            return keyAction.closeSelect;
        }
    }
};
const getUpdatedIndex = (currentIndex, maxIndex, action) => {
    switch (action) {
        case keyAction.pageUp:
        case keyAction.first:
            return 0;
        case keyAction.pageDown:
        case keyAction.last:
            return maxIndex;
        case keyAction.previous:
            return Math.max(0, currentIndex - 1);
        case keyAction.next:
            if (currentIndex == null)
                return 0;
            return Math.min(maxIndex, currentIndex + 1);
        default:
            return currentIndex;
    }
};
export class AxDropdownEvents {
    constructor(selector, options) {
        this.jqElementHelper = new JQElementHelper();
        this.$parents = $(selector);
        this.interaction = new AxDropdownInteraction(options);
        this.options = options;
        this.interaction.openSubject = new Subject();
        this.interaction.onShownSubject = new Subject();
        this.interaction.changeSubject = new BehaviorSubject(null);
        this.createIntersectionObserver();
        this.jqElementHelper.iterateSelector(this.$parents, ($elem) => {
            const $menu = $elem.find('.ax-dropdown__menu');
            const isMultiSelect = this.interaction.hasMultiSelectClass($elem);
            const instance = tippy($elem[0], {
                content: $menu[0],
                allowHTML: true,
                placement: 'bottom',
                trigger: 'click',
                arrow: false,
                interactive: true,
                maxWidth: 'none',
                animation: false,
                onShow: (instance) => {
                    let $parent = $(instance.reference);
                    let $popperInstance = $(instance.popper);
                    instance.popper.style.width = instance.reference.getBoundingClientRect().width + 'px';
                    this.interaction.afterOpen($parent, $popperInstance);
                },
                onShown(instance) {
                    let $parent = $(instance.reference);
                    let $popperInstance = $(instance.popper);
                    //instance.popper.style.width = instance.reference.getBoundingClientRect().width + 'px';
                    this.interaction.afterOnShown($parent, $popperInstance);
                },
                appendTo: () => document.body,
            });
            const $parent = $(instance.reference);
            this.assignIntersectionObserver($parent);
            const $popperInstance = $(instance.popper);
            let $selectedList = $popperInstance.find('.ax-dropdown__item.selected');
            if ($selectedList.length > 0) {
                for (let selected of $selectedList) {
                    const $selected = $(selected);
                    if (isMultiSelect) {
                        $selected.removeClass('selected');
                    }
                    this.interaction.select($selected, $elem);
                }
            }
            this.assignSelectEvent($parent, $popperInstance);
            this.assignSearchEvent($parent, $popperInstance);
            this.assignMultiSelectDelete($parent, $popperInstance);
            this.assignResetEvent($parent, $popperInstance);
            this.assignKeyEvents($parent);
        });
    }
    assignResetEvent($parent, $popperElem) {
        $parent.on("click", ".ax-dropdown--reset", (event) => {
            $parent.find('.ax-dropdown__trigger').removeClass('has-selection');
            $parent.find(".ax-dropdown__selection").text("");
            let currentTarget = $popperElem.find(".ax-dropdown__item.selected");
            if (currentTarget.length > 0) {
                currentTarget.removeClass("selected");
            }
            $(event.currentTarget).remove();
        });
    }
    assignMultiSelectDelete($parent, $popperElem) {
        const hasMultiSelect = this.options.multiSelect && $parent.hasClass('ax-dropdown--multiselect');
        if (hasMultiSelect) {
            $parent.on("click", ".ax-dropdown__muli-remove", (e) => {
                e.preventDefault();
                const id = $(e.currentTarget).parent().attr("data-value");
                this.interaction.deleteMultiSelection($parent, id, $popperElem);
            });
        }
    }
    assignSearchEvent($parent, $popperElem) {
        if (this.options.searchBar || $parent.hasClass('ax-dropdown--hero')) {
            $popperElem.find(".ax-dropdown__search-input").on("keyup", e => {
                e.preventDefault();
                const $target = $(e.delegateTarget);
                this.interaction.search($target, $parent, $popperElem);
            });
        }
    }
    assignSelectEvent($parent, $popperElem) {
        const hasMultiSelect = this.options.multiSelect && $parent.hasClass('ax-dropdown--multiselect');
        if (this.options.multiSelect && !hasMultiSelect) {
            console.warn(`Element is set to multiselect but doesn't contain multiselect class`);
            console.warn($parent);
        }
        $popperElem.find(".ax-dropdown__menu").on("click", '.ax-dropdown__item:not(.ax-dropdown__search)', (e) => {
            const $target = $(e.currentTarget);
            this.interaction.select($target, $parent);
        });
    }
    createIntersectionObserver() {
        if (!this.options.hideOnOutOfScreen)
            return;
        const options = {
            root: window.document,
            rootMargin: "0px",
            threshold: 1,
        };
        const interSectionCallback = (entries, observer) => {
            for (let entry of entries) {
                this.interaction.close($(entry.target));
            }
        };
        this.observer = new IntersectionObserver(interSectionCallback, options);
    }
    assignIntersectionObserver($parent) {
        if (this.options.hideOnOutOfScreen) {
            this.observer.observe($parent[0]);
        }
    }
    assignKeyEvents($parent) {
        $parent.on('keydown', (e) => {
            const { key } = e;
            const tippy = this.interaction.getTippyInstance($parent);
            const popper = tippy.popper;
            const items = $('.ax-dropdown__item', popper);
            const action = getAction(e, tippy.state.isVisible);
            const currentIndex = $('.ax-dropdown__item.selected', popper).index();
            switch (action) {
                case keyAction.last:
                case keyAction.first:
                    return this.interaction.toggle($parent, true);
                case keyAction.next:
                case keyAction.previous:
                case keyAction.pageUp:
                case keyAction.pageDown:
                    e.preventDefault();
                    return this.interaction.selectIndex(getUpdatedIndex(currentIndex, items.length - 1, action), $parent, e);
                case keyAction.closeSelect:
                    e.preventDefault();
                case keyAction.close:
                    e.preventDefault();
                    return this.interaction.toggle($parent, false);
                case keyAction.type:
                    this.interaction.toggle($parent, true);
                    const index = this.searchDropdown(key, $parent);
                    if (index == -1)
                        return;
                    return this.interaction.selectIndex(index, $parent, e);
                case keyAction.open:
                    e.preventDefault();
                    return this.interaction.toggle($parent, true);
            }
        });
    }
    searchDropdown(value, $parent) {
        const searchText = value.toLowerCase();
        const tippy = this.interaction.getTippyInstance($parent);
        const popper = tippy.popper;
        const items = $('.ax-dropdown__item', popper);
        for (let i = 0; i < items.length; i++) {
            const optionText = items[i].textContent.toLowerCase();
            if (optionText.includes(searchText)) {
                return i;
            }
        }
        return -1;
    }
}
